import { gql } from "@apollo/client"

export const GET_SUGGESTED_USERS = gql`
  query getSuggestedUsers($group: ID!, $first: Int, $skip: Int, $search: String) {
    suggestedUsers(group: $group, first: $first, skip: $skip, search: $search) {
      firstName
      lastName
      email
      organization {
        id
      }
    }
  }
`
